import React from 'react'
import {Link} from "react-router-dom";

const DroppedMenuList = ({title, list, filterName, category}) => {
  if (list.length > 7) {
    list
      .sort((a, b) => Math.random() - 0.5)
      .splice(6);

    list.push('Все');
  }

  const itemList = list.map(item => (
    <li className="dropped-menu__item" key={item}>
      <Link to={{
        pathname: `/catalogue`,
        state: {
          category,
          filter: {
            filterName,
            value: item !== 'Все' ? item : ''
          }
        }
      }}>
        {item}
      </Link>
    </li>
  ));

  return (
    <div className="dropped-menu__lists">
      <h3 className="dropped-menu__list-title">{title}:</h3>
      <ul className="dropped-menu__list">
        {itemList}
      </ul>
    </div>
  )
};

DroppedMenuList.defaultProps = {
  list: []
};

export default DroppedMenuList
